import Component from './CustomHeader';

import { connect } from 'react-redux';

// on map le state de redux sur les props du composant
const mapStateToProps = (state, props) => {
  // const {globalKey,flow} = state.app;

  return {

  };
};

export default connect(mapStateToProps, undefined)(Component);
